import SearchBar from '@/home/common/SearchBar';
import {
  Band,
  BandContent,
  BandHeading,
  SearchWrapper
} from './KeepShoppingBand.styles';

export default function KeepShoppingBand() {
  return (
    <Band>
      <BandContent>
        <BandHeading>Looking for something different?</BandHeading>
        <SearchWrapper>
          <SearchBar className="w-full" />
        </SearchWrapper>
      </BandContent>
    </Band>
  );
}
